module.exports = __webpack_public_path__ + "media/images/aircraft-1-7358384c3709d5ede0d2ad10437977cb.jpg";